// Thunks extracted from AssessmentModule.js

import _ from "lodash";
import update from "immutability-helper";
import {
  writeAssessmentFieldFragment,
  getAssessmentDetailsFromCache,
  writeAssessmentFragment,
} from "../AssessmentGraphqlHelpers";
import { getUnitPlanDetailsFromCache } from "IBPlanner/modules/IBGraphqlHelpers";
import { getUnitPlanFieldResponseFilter } from "UnitPlans/modules/Utils";
import { generateRandomIdV2, getRelativePath } from "Utils";
import {
  getUnitPlanResourceLibraryFromCache,
  writeUnitPlanResourceLibraryInCache,
} from "UnitPlans/modules/UnitPlanGraphqlHelpers";
import {
  updateAssessmentMutation,
  createAssessmentMutation,
  deleteAssessmentMutation,
  clearAssessmentToolMutation,
  removeAssessmentToolMutation,
  updateAssessmentToolSettingMutation,
  createCourseFlowResourceMutation,
} from "../AssessmentMutations";
import { goToRelativeRoute, openLinkInNewTab } from "modules/Services";
import { getResolvedOptimisticValue } from "modules/ElementValueUtils";
import { ASSESSMENT_TOOLS_OBJ } from "@toddle-edu/common-utils";
import client from "lib/apolloClient/client";
import { setToastMsg, getUserInfo } from "Login/modules/LoginModule";
import {
  importAssessmentV2Mutation,
  importAssessmentMutation,
} from "UnitPlans/modules/UnitPlanMutations";
import { recordEvent } from "lib/eventTracker";
import { colors } from "Constants";
import { goToResourceDetails } from "modules/NavigationModule/NavigationThunks";
import { getChildResourcesFeedQuery } from "OrganizationResources/modules/OrganizationResourcesQuery";
import { getUnitPlanCentralRepoInputAndFilters } from "Courses/modules/utils";
import {
  writeAssessmentToolOfParentInCache,
  getAssessmentToolOfParentFromCache,
} from "modules/AssessmentTool/AssessmentToolGraphqlHelpers";
import { isWorksheetQueriesV2Enabled } from "Worksheet/modules/WorksheetFeatureFlags";

import ACLStore from "lib/aclStore";
import { ENABLE_GRADE_WISE_ASSESSMENT } from "Constants/permissionConstants";
import { getCourseDetailsFromCache } from "Course/modules/CourseGraphqlHelpers";
import {
  getSelectedCourseId,
  getCourseId,
  getSelectedAcademicYearId,
  getCurrentCurriculumProgramType,
  getSelectedCurriculumId,
} from "modules/CommonSelectors";
import {
  getAssessmentFromLocalStorage,
  getPlannerElementLabel,
  getResolvedMinimalTree,
  getResolvedMinimalTreeSet,
  removeAssessmentFromLocalStorage,
} from "../Utils";
import { getNodeParents } from "Utils/nodeParentHelpers";
import {
  ASSESSMENT_TYPE_AI_TUTOR,
  TODDLE_LIBRARY,
  MYP_OBJECTIVE_RUBRIC,
  MYP_INTERDISCIPLINARY_CRITERIA_RUBRIC,
  MYP_SUBJECT_SPECIFIC,
  STANDARD_BASED_RUBRIC,
  GRADE_SCALE_TOOL,
} from "Constants/stringConstants";
import { addAssignmentActivity } from "ClassRoom/modules/ClassRoomModule";
import {
  getDateTimeDifference,
  getDateMomentObject,
} from "Utils/DateTimeHelpers";
import moment from "moment";
import { getAITutorInitialFieldValues } from "ClassRoom/modules/utils";
import { getLearningCourseFlowResourceQuery } from "UnitFlowV3/modules/LearningCourseFlow/Query";
import { getAssignmentEditDetailsFromCache } from "ClassRoom/modules/ClassRoomGraphqlHelpers";
import { getCurrentAssessmentTypes } from "Platform/modules/PlatformModule";
import { Sentry } from "services/sentry";
import { getUnitFlowModuleFuncs } from "UnitFlowV3/modules/UnitFlowModule";
import { joinWithCommaAnd } from "Utils/StringHelpers";
import { getSelectedLearningCourseId } from "Teacher/routes/LearningCourse/modules/Utils";
import {
  getIsLearningCoursesEnabled,
  getIsSubjectBasedGradingEnabled,
} from "Teacher/routes/LearningCourses/modules/Utils";
import { getUnitFlowUtils } from "UnitFlowV3/modules/utils";
import { saveFieldUpdateActivityStatus } from "./AssessmentActions";
import {
  ENABLED_TASK_GROUP,
  recursiveSearchAndRemove,
  recursiveSearchAndUpdate,
  _updateAssessmentTools,
  processToolForCacheUpdate,
  FIELD_KEYS_TO_PICK,
  getAssessmentBasicDetails,
  getPlannerTemplates,
} from "./AssessmentUtils";
import { getGradeIdFromGlobalFilter } from "Login/routes/ToddleLibrary/modules/ToddleLibraryUtils";
import { getUnitViewType } from "UnitPlans/modules/UnitViewModeUtils";
import { OLD_UNIT_VIEW } from "UnitPlanDetails/modules/stringConstants";

// Thunks
export const gotoAssessmentDetails = ({
  id,
  mode = "view",
  isOpenInNewTab = true,
  routePostFix = "",
  target,
  skipRouteCheck = false,
  resourceType = "ASSESSMENT",
  shouldOpenSubmissions = false,
}) => {
  return async (dispatch, getState) => {
    const activeTab = getState().login.activeTab;

    if (activeTab === TODDLE_LIBRARY) {
      // #hack toddle library
      isOpenInNewTab = true;
      target = "fullscreen";
    }

    let qs = "";
    if (target) {
      qs = `?target=${target}`;
    }

    let route = `${routePostFix}assessment/${id}/${mode}${qs}`;

    if (_.isEqual(resourceType, "WORKSHEET") && activeTab === TODDLE_LIBRARY) {
      const gradeId = getGradeIdFromGlobalFilter();
      route = `${routePostFix}worksheet/${id}?gradeId=${gradeId}`;
    }

    if (isOpenInNewTab) {
      let replacePath = "";
      let routePath = route;
      if (!skipRouteCheck) {
        replacePath =
          activeTab == "community"
            ? ""
            : activeTab == "admin"
            ? `administrator`
            : activeTab === TODDLE_LIBRARY
            ? "toddle-library"
            : `courses`;

        routePath =
          activeTab == "community" ? route : `${replacePath}/${route}`;
      }

      const path = getRelativePath(routePath, `${replacePath}`);
      dispatch(openLinkInNewTab({ url: path }));
    } else {
      dispatch(goToRelativeRoute({ route, state: { shouldOpenSubmissions } }));
    }
  };
};

export const onClose = () => {
  return (dispatch, getState) => {
    // This is to identify the old url and the new url
    // The new url looks like '/community/assesment/:assesmentId/view' and has 4 nodes
    // The old url looks like '/community/home/featured/all/assesment/:assesmentId/view' as has atleast 6 nodes
    // The pathname after a split will have an empty string so the magic number here is (4+1)
    const activeTab = getState().login.activeTab;

    const currentPath = window.location.pathname;

    const currentPathNodes = currentPath.split("/");

    let replacePath = "assessment";
    let route = "./";

    // if assessment is opened through sym link then redirect user to platform (home)
    if (_.includes(currentPath, "links")) {
      replacePath = "platform";
      route = `platform/${getSelectedCurriculumId(getState())}`;
    }

    if (currentPathNodes.length > 5 || activeTab == "TODDLE_LIBRARY") {
      if (activeTab == "TODDLE_LIBRARY") {
        const searchParams = new URLSearchParams(window.location.search);
        const searchText = searchParams.get("searchText");
        route += searchText ? `?searchText=${searchText}` : "";
      }

      dispatch(
        goToRelativeRoute({
          replacePath,
          type: "replace",
          route,
        })
      );
    }
  };
};

export const onClickEdit = () => {
  return (dispatch, getState) => {
    dispatch(goToRelativeRoute({ route: `../edit`, type: "replace" }));
  };
};

export const clearAssessmentTool = ({ clearAssessmentTool = true }) => {
  return async (dispatch, getState) => {
    const userInfo = getUserInfo();
    await client.mutate({
      mutation: clearAssessmentToolMutation,
      variables: {
        assessmentId: getState().assessment.assessmentData.assessmentId,
        updatedBy: userInfo.id,
        clearAssessmentTool,
      },
    });
  };
};

export const removeSubjectDependencies = params => {
  const {
    subjectDependencies,
    parentId,
    parentType,
    portalType,
    fieldList,
    updateInputField,
    onRemove,
    shouldUseLocalUpdateFunction = false,
  } = params;

  return dispatch => {
    _.forEach(subjectDependencies, subjectDependency => {
      const { fieldsToUpdate } = subjectDependency || {};

      const addLearningGoalsField = _.get(fieldList, "addLearningGoals", {});
      const learningGoalsOptions = _.get(
        addLearningGoalsField,
        "config.options",
        []
      );
      const learningGoalsFields = _.map(learningGoalsOptions, ({ key }) => key);

      _.forEach(fieldsToUpdate, (value, key) => {
        const isAssessmentTool = ASSESSMENT_TOOLS_OBJ[key];
        if (isAssessmentTool) {
          dispatch(
            removeAssessmentTool({
              id: value,
              type: key,
              parentId,
              parentType,
              portalType,
            })
          );
        } else {
          const hasAddRemoveValues = _.get(
            fieldList,
            `${key}.config.hasAddRemoveValues`,
            false
          );
          if (shouldUseLocalUpdateFunction) {
            const extramParams =
              _.includes(learningGoalsFields, key) && _.isEmpty(value)
                ? { nodes: [], rootNodeId: "" }
                : {};
            updateInputField(
              {
                [key]: value,
              },
              extramParams,
              true,
              hasAddRemoveValues
            );
          } else {
            updateInputField({
              params: {
                [key]: value,
              },
              extraParams: {},
              isWarningReq: true,
              hasAddRemoveValues,
              isMutation: true,
            });
          }
        }
      });
    });

    onRemove?.();
  };
};

export const removeAssessmentTool = ({
  id,
  type,
  parentId,
  parentType,
  portalType,
  writeToCache = true,
}) => {
  return async (dispatch, getState) => {
    const state = getState();
    const assessmentId = _.get(
      state,
      "assessment.assessmentData.assessmentId",
      ""
    );
    const academicYearId = getSelectedAcademicYearId(state);
    const isWorksheetQueriesV2 = isWorksheetQueriesV2Enabled();

    const parentAssessmentToolDetails = getAssessmentToolOfParentFromCache({
      id: parentId,
      type: parentType,
      assessmentId,
      academicYearId,
    });

    if (writeToCache) {
      let updatedAssessmentDetails;
      if (parentType === "QUESTION") {
        if (!isWorksheetQueriesV2) {
          //WORKSHEET_RESTRUCTURING: Remove this block when queriesV2 is enabled
          const newOrganizationResources = _.map(
            _.get(
              parentAssessmentToolDetails,
              "organizationResourcesV2.edges[0].node.childrenV2.edges"
            ),
            orgResource => {
              const newEdges = recursiveSearchAndRemove({
                edges: _.get(orgResource, "node.childrenV2.edges"),
                parentId,
                assessmentToolId: id,
              });

              return update(orgResource, {
                node: {
                  childrenV2: { edges: { $set: newEdges } },
                },
              });
            }
          );

          updatedAssessmentDetails = update(parentAssessmentToolDetails, {
            organizationResourcesV2: {
              edges: {
                [0]: {
                  node: {
                    childrenV2: {
                      edges: {
                        $set: newOrganizationResources,
                      },
                    },
                  },
                },
              },
            },
          });
        } else {
          const questions = _.get(
            parentAssessmentToolDetails,
            "questions.edges",
            []
          );
          const question = _.find(questions, { id: parentId });

          const assessmentTools = _.get(question, "assessmentTools.edges", []);

          const assessmentToolNodes = _.filter(assessmentTools, ({ node }) => {
            const assessmentToolId = _.get(node, "assessmentToolItem.id", "");
            return assessmentToolId !== id;
          });

          const updatedQuestion = {
            ...question,
            assessmentTools: {
              ..._.get(question, "assessmentTools", {}),
              edges: assessmentToolNodes,
              totalCount: _.size(assessmentToolNodes),
            },
          };
          updatedAssessmentDetails = {
            ...parentAssessmentToolDetails,
            questions: {
              ..._.get(parentAssessmentToolDetails, "questions", {}),
              edges: _.map(questions, q => {
                if (_.isEqual(q.id, question.id)) {
                  return updatedQuestion;
                }
                return q;
              }),
            },
          };
        }
      } else {
        const assessmentTools = _.get(
          parentAssessmentToolDetails,
          "assessmentTools.edges",
          []
        );

        const assessmentToolNodes = _.filter(assessmentTools, ({ node }) => {
          const assessmentToolId = _.get(node, "assessmentToolItem.id", "");
          return assessmentToolId !== id;
        });

        updatedAssessmentDetails = {
          ...parentAssessmentToolDetails,
          assessmentTools: {
            edges: assessmentToolNodes,
            __typename: "AssessmentToolConnection",
          },
        };
      }

      setTimeout(() =>
        writeAssessmentToolOfParentInCache({
          id: parentId,
          data: updatedAssessmentDetails,
          type: parentType,
          academicYearId,
        })
      );
    }

    try {
      if (!_.isEmpty(parentId)) {
        await client.mutate({
          mutation: removeAssessmentToolMutation,
          variables: {
            assessmentId: parentId,
            removeAssessmentToolData: [{ id, type }],
            parentType,
            portalType,
          },
        });
      } else {
        dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      }
    } catch (e) {
      setTimeout(() =>
        writeAssessmentToolOfParentInCache({
          id: parentId,
          data: parentAssessmentToolDetails,
          type: parentType,
          academicYearId,
        })
      );
    }
  };
};

export const removeAssessmentTools = tools => {
  return async (dispatch, getState) => {
    const state = getState();
    const originalToolsData = new Map();
    const academicYearId = getSelectedAcademicYearId(state);
    const isWorksheetQueriesV2 = isWorksheetQueriesV2Enabled();

    // Process each tool to prepare for removal and update the cache
    const removeAssessmentToolData = _.map(tools, tool => {
      const assessmentId = _.get(
        state,
        "assessment.assessmentData.assessmentId",
        ""
      );

      const parentAssessmentToolDetails = getAssessmentToolOfParentFromCache({
        id: _.get(tool, "parentId"),
        type: _.get(tool, "parentType"),
        assessmentId,
        academicYearId,
      });

      // Store a deep clone of the original data for potential rollback
      _.set(
        originalToolsData,
        tool?.id,
        _.cloneDeep(parentAssessmentToolDetails)
      );

      if (tool?.writeToCache) {
        const updatedAssessmentDetails = processToolForCacheUpdate(
          tool,
          _.cloneDeep(parentAssessmentToolDetails),
          isWorksheetQueriesV2
        );

        // Update cache immediately for each tool
        writeAssessmentToolOfParentInCache({
          id: tool.parentId,
          data: updatedAssessmentDetails,
          type: tool.parentType,
          academicYearId,
        });
      }

      return { id: tool.id, type: tool.type };
    });

    try {
      // Mutation to remove tools

      if (!_.isEmpty(_.get(tools, "[0].parentId"))) {
        await client.mutate({
          mutation: removeAssessmentToolMutation,
          variables: {
            assessmentId: _.get(tools, "[0].parentId"),
            removeAssessmentToolData,
            parentType: _.get(tools, "[0].parentType"),
            portalType: _.get(tools, "[0].portalType"),
          },
        });
      } else {
        dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      }
    } catch (e) {
      // Rollback in case of an error
      _.forEach(tools, tool => {
        writeAssessmentToolOfParentInCache({
          id: tool.parentId,
          data: originalToolsData.get(tool.id),
          type: tool.parentType,
          academicYearId,
        });
      });
    }
  };
};

export const updateAssessmentInCache = ({
  fieldUID,
  params,
  fieldObj,
  extraParams,
  fieldTemplateObj,
}) => {
  return (dispatch, getState) => {
    const resolvedMinimalTree = getResolvedOptimisticValue({
      resolvedValue: _.get(fieldObj, "resolvedMinimalTree", {}),
      fieldUID,
      fieldTemplateObj,
      params: extraParams,
      value: _.get(params, "value", ""),
    });

    const data = {
      ...fieldObj,
      value: params.value,
      resolvedMinimalTree,
    };

    writeAssessmentFieldFragment({ data, field_id: params.id });
  };
};

export const updateAssessment = params => {
  return (dispatch, getState) => {
    const userInfo = getUserInfo();
    const {
      portalType = "PLANNER",
      academicTermId,
      categoryId,
      globalCategories,
      scoreToolData,
      weightage,
      isLearningGoalsEvaluationEnabled,
      hasFields = true,
      courseId,
      unitPlanId,
      isCopyIntoUnitPlan,
      isMoveIntoUnitPlan,
      isDeleteFromUnitPlan,
      fields,
      toastMsg,
    } = params || {};

    const assessmentId =
      params?.assessmentId || getState().assessment.assessmentData.assessmentId;

    let variables = {
      assessmentId,
      updatedBy: userInfo.id,
      isLearningGoalsEvaluationEnabled,
      portalType,
      academicTermId,
      categoryId,
      globalCategories,
      scoreToolData,
      weightage,
      courseId,
      unitPlanId,
      isCopyIntoUnitPlan,
      isMoveIntoUnitPlan,
      isDeleteFromUnitPlan,
    };

    if (hasFields) {
      const _fields = fields
        ? _.map(fields, field => _.pick(field, FIELD_KEYS_TO_PICK))
        : _.pick(params, FIELD_KEYS_TO_PICK);
      variables = {
        ...variables,
        fields: _fields,
      };

      const hasDescriptionUpdateFromAIInput = _.isArray(_fields)
        ? _.some(_fields, { isDescriptionUpdateFromAIInput: true })
        : _.get(_fields, "isDescriptionUpdateFromAIInput", false);

      if (hasDescriptionUpdateFromAIInput) {
        variables.isDescriptionUpdateFromAIInput = true;
      }
    }
    const mutationPromise = client.mutate({
      mutation: updateAssessmentMutation,
      variables,
    });

    if (!_.isEmpty(toastMsg)) {
      dispatch(
        setToastMsg({
          type: "success",
          msg: toastMsg,
        })
      );
    }

    return mutationPromise;
  };
};

export const importAssessment = ({
  sourceAssessmentId,
  unitId = null,
  portalType,
  eventTarget,
  title,
  isCopy,
  courseId,
  learningCourseId,
  groupType = "LEARNING_ENGAGEMENT",
  assessmentTypes,
  academicYears = [],
  userInfoPortalType = "PLANNER",
  selectedUnitCurriculumProgramId,
  destination = null,
  shouldFetchUnitPlanIdFromState = true,
  createEntityFlowResource,
}) => {
  return async (dispatch, getState) => {
    const state = getState();

    let unitPlanId = unitId;
    if (!unitId && shouldFetchUnitPlanIdFromState) {
      const unitPlanData = state.planner?.unitPlanData;
      unitPlanId = unitPlanData?.unitPlanId;
    }
    const organizationUserInfo = getUserInfo({
      portalType: userInfoPortalType,
    });
    const organizationId = organizationUserInfo.org_id;
    const curriculumProgramId =
      selectedUnitCurriculumProgramId ||
      _.get(state, "platform.currentCurriculumProgram.id");

    const isLearningCoursesEnabled = getIsLearningCoursesEnabled({
      curriculumProgramId,
    });

    const filters = state.assessment.filters;

    const unitPlanResourceDetails = getUnitPlanResourceLibraryFromCache({
      id: unitPlanId,
      filters,
    });
    let fields = undefined;
    if (title) {
      fields = [
        ...(fields || []),
        {
          fieldUid: "title",
          value: title,
        },
      ];
    }
    try {
      const resourceEdges = _.get(
        unitPlanResourceDetails.resourceLibrary,
        "edges",
        []
      );

      const _courseId = courseId || getCourseId(state);
      const _learningCourseId =
        learningCourseId || getSelectedLearningCourseId(state);

      const result = await client.mutate({
        mutation: importAssessmentMutation,
        variables: {
          sourceAssessmentId,
          targetUnitPlanId: unitPlanId,
          portalType,
          fields,
          academicYears,
          sourceOrganizationId: organizationId,
          targetCurriculumProgramId: curriculumProgramId,
          courseId: !_.isEmpty(_courseId) ? _courseId : null,
          learningCourseId: !_.isEmpty(_learningCourseId)
            ? _learningCourseId
            : null,
          createEntityFlowResource: _.isNil(createEntityFlowResource)
            ? null
            : createEntityFlowResource,
        },
        update: (
          cache,
          {
            data: {
              planner: { importAssessment },
            },
          }
        ) => {
          const updatedResourceEdges = [
            {
              type: groupType,
              node: importAssessment,
              __typename: "ResourceLibraryEdge",
            },
            ...resourceEdges,
          ];

          const data = {
            ...unitPlanResourceDetails,
            resourceLibrary: {
              ...unitPlanResourceDetails.resourceLibrary,
              assessmentCount: _.get(updatedResourceEdges, "length", 0),
              edges: updatedResourceEdges,
            },
          };

          const assessmentType = _.get(
            importAssessment,
            "assessmentType.value",
            ""
          );

          writeUnitPlanResourceLibraryInCache({
            id: unitPlanId,
            data,
            filters,
          });

          const onToastClick = () => {
            if (!isCopy) {
              dispatch(
                goToResourceDetails({
                  id: _.get(importAssessment, "id", ""),
                  unitPlanId,
                  courseId,
                  type: "assessment",
                  isOpenInNewTab: true,
                })
              );
            }
          };

          const currentAssessmentTypes = dispatch(getCurrentAssessmentTypes());
          const { localeLabel } =
            _.get(currentAssessmentTypes, assessmentType) || {};

          let toastMsg;

          if (isCopy) {
            toastMsg = "toastMsgs:label_successfully_duplicated";
          } else if (_.isEqual(assessmentType, "worksheet")) {
            toastMsg = "toastMsgs:worksheet_added_successfully";
          } else if (
            isLearningCoursesEnabled &&
            destination === "COURSE_FLOW"
          ) {
            toastMsg = "toastMsgs:entity_added_successfully";
          } else {
            toastMsg = "toastMsgs:le_successfully_imported";
          }

          dispatch(
            setToastMsg({
              msg: toastMsg,
              type: "success",
              position: "toast-bottom-left",
              isClosable: !isCopy,
              onClick: onToastClick,
              variant: "inline",
              locale_params: [
                { key: "label", value: localeLabel, isPlainText: false },
                { key: "entity", value: localeLabel, isPlainText: false },
              ],
              primaryAction: !isCopy && {
                label: _.isEqual(assessmentType, "worksheet")
                  ? "toastMsgs:edit_worksheet"
                  : "toastMsgs:view",
                onClick: onToastClick,
              },
            })
          );
        },
      });
      if (!!eventTarget && !!unitPlanId) {
        recordEvent({
          eventName: "import le in unit",
          eventData: {
            target: eventTarget,
            entity_id: sourceAssessmentId,
            entity_type: "ASSESSMENT",
            unit_id: unitPlanId,
            source: "community",
            entity_name: title,
          },
        });
      }

      if (!_.get(result, "data.planner.importAssessment.id", null)) {
        Sentry.captureMessage(`IMPORT_ASSESSMENT_ERROR`, {
          level: "info",
          extra: {
            sourceAssessmentId,
          },
        });
      }

      return _.get(result, "data.planner.importAssessment.id", null);
    } catch (e) {
      Sentry.captureMessage(`IMPORT_ASSESSMENT_ERROR`, {
        level: "info",
        extra: {
          sourceAssessmentId,
          reason: _.get(e, "message", ""),
        },
      });

      writeUnitPlanResourceLibraryInCache({
        id: unitPlanId,
        data: unitPlanResourceDetails,
        filters,
      });
      dispatch(
        setToastMsg({
          msg: "toastMsgs:something_went_wrong",
          type: "warning",
          position: "toast-bottom-left",
        })
      );
      return false;
    }
  };
};

export const importAssessmentV2 = ({
  sourceAssessmentIds,
  unitId = null,
  portalType,
  eventTarget,
  title,
  isCopy,
  courseId,
  learningCourseId,
  groupType = "LEARNING_ENGAGEMENT",
  academicYears = [],
  userInfoPortalType = "PLANNER",
  selectedUnitCurriculumProgramId,
  destination = null,
  shouldFetchUnitPlanIdFromState = true,
  createEntityFlowResource,
}) => {
  return async (dispatch, getState) => {
    const state = getState();

    let unitPlanId = unitId;
    if (!unitId && shouldFetchUnitPlanIdFromState) {
      const unitPlanData = state.planner?.unitPlanData;
      unitPlanId = unitPlanData?.unitPlanId;
    }
    const organizationUserInfo = getUserInfo({
      portalType: userInfoPortalType,
    });
    const organizationId = organizationUserInfo.org_id;
    const curriculumProgramId =
      selectedUnitCurriculumProgramId ||
      _.get(state, "platform.currentCurriculumProgram.id");

    const isLearningCoursesEnabled = getIsLearningCoursesEnabled({
      curriculumProgramId,
    });

    const filters = state.assessment.filters;
    const unitViewType = getUnitViewType();

    const unitPlanResourceLibraryDetails = getUnitPlanResourceLibraryFromCache({
      id: unitPlanId,
      filters,
    });
    let fields = undefined;
    if (title) {
      fields = [
        ...(fields || []),
        {
          fieldUid: "title",
          value: title,
        },
      ];
    }
    try {
      const resourceEdges = _.get(
        unitPlanResourceLibraryDetails.resourceLibrary,
        "edges",
        []
      );

      const _courseId = courseId || getCourseId(state);
      const _learningCourseId =
        learningCourseId || getSelectedLearningCourseId(state);

      const result = await client.mutate({
        mutation: importAssessmentV2Mutation,
        variables: {
          sourceAssessmentIds,
          targetUnitPlanId: unitPlanId,
          portalType,
          fields,
          academicYears,
          sourceOrganizationId: organizationId,
          targetCurriculumProgramId: curriculumProgramId,
          courseId: !_.isEmpty(_courseId) ? _courseId : null,
          learningCourseId: !_.isEmpty(_learningCourseId)
            ? _learningCourseId
            : null,
          createEntityFlowResource: _.isNil(createEntityFlowResource)
            ? null
            : createEntityFlowResource,
        },
        update: (
          cache,
          {
            data: {
              planner: { importAssessmentV2 },
            },
          }
        ) => {
          const importedAssessments = importAssessmentV2 || [];

          const newEdges = importedAssessments.map(assessment => ({
            type: groupType,
            node: assessment,
            __typename: "ResourceLibraryEdge",
          }));

          const updatedResourceEdges = [...newEdges, ...resourceEdges];

          const data = {
            ...unitPlanResourceLibraryDetails,
            resourceLibrary: {
              ...unitPlanResourceLibraryDetails.resourceLibrary,
              assessmentCount: _.get(updatedResourceEdges, "length", 0),
              edges: updatedResourceEdges,
            },
          };

          if (unitViewType === OLD_UNIT_VIEW) {
            writeUnitPlanResourceLibraryInCache({
              id: unitPlanId,
              data,
              filters,
            });
          }

          const importedCount = importedAssessments.length;
          let toastMsg;

          if (isCopy) {
            toastMsg = "toastMsgs:label_successfully_duplicated";
          } else if (importedCount > 1) {
            toastMsg = "toastMsgs:le_successfully_imported";
          } else {
            const assessmentType = _.get(
              importedAssessments[0],
              "assessmentType.value",
              ""
            );
            if (_.isEqual(assessmentType, "worksheet")) {
              toastMsg = "toastMsgs:worksheet_added_successfully";
            } else if (
              isLearningCoursesEnabled &&
              destination === "COURSE_FLOW"
            ) {
              toastMsg = "toastMsgs:entity_added_successfully";
            } else {
              toastMsg = "toastMsgs:le_successfully_imported";
            }
          }

          // assessmentType is required only to get localeLabel
          // localeLable is only used when we have a single assessment import
          // else toastMsg will always be generic
          const assessmentType = _.get(
            importedAssessments[0],
            "assessmentType.value",
            ""
          );

          const currentAssessmentTypes = dispatch(getCurrentAssessmentTypes());
          const { localeLabel } =
            _.get(currentAssessmentTypes, assessmentType) || {};

          const isSingleAssessment = importedAssessments.length === 1;

          const onToastClick = () => {
            if (!isCopy && isSingleAssessment) {
              dispatch(
                goToResourceDetails({
                  id: _.get(importedAssessments[0], "id", ""),
                  unitPlanId,
                  courseId,
                  type: "assessment",
                  isOpenInNewTab: true,
                })
              );
            }
          };

          dispatch(
            setToastMsg({
              msg: toastMsg,
              type: "success",
              position: "toast-bottom-left",
              isClosable: !isCopy && isSingleAssessment,
              variant: "inline",
              onClick: onToastClick,
              locale_params: [
                { key: "label", value: localeLabel, isPlainText: false },
                { key: "entity", value: localeLabel, isPlainText: false },
              ],
              primaryAction: !isCopy &&
                isSingleAssessment && {
                  label: _.isEqual(assessmentType, "worksheet")
                    ? "toastMsgs:edit_worksheet"
                    : "toastMsgs:view",
                  onClick: onToastClick,
                },
            })
          );
        },
      });
      if (!!eventTarget && !!unitPlanId) {
        recordEvent({
          eventName: "bulk import le in unit",
          eventData: {
            target: eventTarget,
            entity_id: [sourceAssessmentIds],
            entity_type: "ASSESSMENT",
            unit_id: unitPlanId,
            source: "community",
            entity_name: title,
          },
        });
      }

      const importedAssessments = _.get(
        result,
        "data.planner.importAssessmentV2",
        []
      );
      const importedAssessmentIds = _.map(importedAssessments, "id");

      if (_.isEmpty(importedAssessmentIds)) {
        Sentry.captureMessage(`IMPORT_ASSESSMENT_ERROR`, {
          level: "info",
          extra: {
            sourceAssessmentIds,
          },
        });
      }

      return importedAssessmentIds;
    } catch (e) {
      Sentry.captureMessage(`IMPORT_ASSESSMENT_ERROR`, {
        level: "info",
        extra: {
          sourceAssessmentIds,
          reason: _.get(e, "message", ""),
        },
      });
      if (unitViewType === OLD_UNIT_VIEW) {
        writeUnitPlanResourceLibraryInCache({
          id: unitPlanId,
          data: unitPlanResourceLibraryDetails,
          filters,
        });
      }
      dispatch(
        setToastMsg({
          msg: "toastMsgs:something_went_wrong",
          type: "warning",
          position: "toast-bottom-left",
        })
      );
      return false;
    }
  };
};

export const cloneAssessment = ({
  sourceAssessmentId,
  portalType,
  academicYears = [],
  selectedCourseId,
  selectedCurriculumId,
  unitPlanId,
  title,
  sourceOrganizationId,
  learningCourseId = null,
}) => {
  return async (dispatch, getState) => {
    const state = getState();

    const userInfo = getUserInfo();
    const organizationId = userInfo.org_id;

    // When cloning an assessment in toddle library portal, we can't have curriculum and course context
    // from platform redux state. So we pass them directly from the function call
    const curriculumProgramId =
      selectedCurriculumId ||
      _.get(state, "platform.currentCurriculumProgram.id");

    const courseId = selectedCourseId || getCourseId(state);

    try {
      const clone = await client.mutate({
        mutation: importAssessmentMutation,
        variables: {
          sourceAssessmentId,
          portalType,
          academicYears,
          sourceOrganizationId: sourceOrganizationId || organizationId,
          targetCurriculumProgramId: curriculumProgramId,
          courseId: !_.isEmpty(courseId) ? courseId : null,
          targetUnitPlanId: unitPlanId,
          learningCourseId,
        },
      });
      const clonedAssessmentId = _.get(
        clone,
        "data.planner.importAssessment.id"
      );
      const clonedAssessmentType = _.get(
        clone,
        "data.planner.importAssessment.assessmentType.value",
        null
      );
      const clonedTitleFieldId = _.get(
        clone,
        "data.planner.importAssessment.title.id",
        null
      );
      if (_.isEmpty(clonedAssessmentId)) {
        Sentry.captureMessage(`IMPORT_ASSESSMENT_ERROR`, {
          level: "info",
          extra: {
            sourceAssessmentId,
          },
        });

        dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      }
      return { clonedAssessmentId, clonedAssessmentType, clonedTitleFieldId };
    } catch (err) {
      Sentry.captureMessage(`IMPORT_ASSESSMENT_ERROR`, {
        level: "info",
        extra: {
          sourceAssessmentId,
          reason: _.get(err, "message", ""),
        },
      });

      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      return false;
    }
  };
};

export const showNotEditableLePlanToast = () => {
  return (dispatch, getState) => {
    dispatch(
      setToastMsg({
        msg: `toastMsgs:no_le_edit_permission`,
        position: "toast-top-center",
        type: "warning",
        fill: colors.yellow500,
      })
    );
  };
};

export const showWorksheetNotEditableToast = () => {
  return (dispatch, getState) => {
    dispatch(
      setToastMsg({
        msg: `toastMsgs:no_worksheet_edit_permission`,
        position: "toast-top-center",
        type: "warning",
        fill: colors.yellow500,
      })
    );
  };
};

export const getAssessmentDataFromLocalStorage = params => {
  const { creationMode } = params || {};

  return async (dispatch, getState) => {
    try {
      const courseId = _.get(
        params,
        "courseId",
        getSelectedCourseId(getState())
      );

      const result = getAssessmentFromLocalStorage({
        courseId,
        creationMode,
      });

      if (!_.isEmpty(result)) {
        let parsedResult = _.first(_.values(result));

        try {
          parsedResult = JSON.parse(result);
        } catch (e) {
          parsedResult = result;
        }

        const assessmentId = _.get(parsedResult, "data.leId");
        const currentStep = _.get(parsedResult, "currentStep");

        if (assessmentId) {
          const assessmentDetails = await getAssessmentBasicDetails({
            id: assessmentId,
          });

          const isDeleted = _.get(assessmentDetails, "isDeleted", false);

          if (!isDeleted) {
            return {
              assessmentId,
              currentStep,
              assessmentData: _.get(parsedResult, "data", {}),
            };
          } else {
            // if assessment has been deleted then remove it from the local storage as well
            const fields = _.get(assessmentDetails, "fields", []);
            const assessmentType = _.get(
              _.find(fields, { uid: "assessmentType" }),
              "value"
            );

            removeAssessmentFromLocalStorage({
              courseId,
              curriculumType: getCurrentCurriculumProgramType(getState()),
              assessmentType,
              creationMode,
            });
          }
        }
      }

      return {};
    } catch (e) {
      console.error(e);
      return {};
    }
  };
};

export const getCreateAssessmentInputData = ({
  assessmentType = "le",
  title = "",
  description = "",
  groupType = "LEARNING_ENGAGEMENT",
  unitPlanObj,
  academicYears = [],
  learningCourseId = null,
  primaryGradeId,
  selectedCurriculumProgramId = "",
  createUnitFlowResource,
  templateId: providedTemplateId,
  taskTypeId,
  ...params
}) => {
  return async (dispatch, getState) => {
    const { org_id: organizationId, id: userId } = getUserInfo({
      portalType: "PLANNER",
    });
    const academicYearId = getSelectedAcademicYearId(getState());

    const unitPlanId = _.get(
      unitPlanObj,
      "unitPlanId",
      _.get(getState(), "planner.unitPlanData.unitPlanId", "")
    );
    const selectedCourseId = _.get(
      getState(),
      "teacher.selected_class.selected_course",
      ""
    );

    const { centralRepoInput } = getUnitPlanCentralRepoInputAndFilters({
      organizationId: organizationId,
      courseId: selectedCourseId,
      academicYearId,
    });
    const assessmentData = getState().assessment.assessmentData;

    const responseFilter = getUnitPlanFieldResponseFilter();
    const collaboratorsFilter = {
      userAcademicYearId: academicYearId,
    };

    const unitPlanDetails = getUnitPlanDetailsFromCache({
      unitPlanId,
      centralRepoInput,
      responseFilter,
      collaboratorsFilter,
      exceptionalCollaboratorsFilter: collaboratorsFilter,
    });
    const unitPlanFields = _.get(unitPlanDetails, "allFields", []);

    const unitType = _.get(
      _.find(unitPlanFields, { uid: "unitType" }),
      "value",
      ""
    );

    const curriculumProgramId =
      selectedCurriculumProgramId ||
      _.get(getState(), "platform.currentCurriculumProgram.id", null);
    // const unitPlanTemplateId = _.get(unitPlanDetails, "templateId", "");
    // const unitPlanTemplate = _.get(
    //   getPlannerTemplateFromCache(unitPlanTemplateId),
    //   "body",
    //   {}
    // );

    // true only for certain groupTypes and if permission is on
    const isGradeWiseAssessment =
      ACLStore.can(ENABLE_GRADE_WISE_ASSESSMENT) &&
      ENABLED_TASK_GROUP.includes(groupType);

    const courseGradeFilters = {
      academicYearId,
    };

    const courseDetails = getCourseDetailsFromCache({
      id: selectedCourseId,
      courseGradeFilters,
    });
    const coursePrimaryGrade = _.get(courseDetails, "primaryGrade.id", null);

    const gradeId = !_.isEmpty(unitPlanDetails)
      ? _.get(unitPlanDetails, "grades.0")
      : coursePrimaryGrade || primaryGradeId;

    let templateId = providedTemplateId;

    if (_.isEmpty(templateId)) {
      const plannerTemplates = await getPlannerTemplates({
        organizationId,
        isGradeWiseAssessment,
        gradeId,
      });

      //Extract a template of particular curriculum(IB_PYP,IB_MYP), particular type (ASSESSMENT,LE) and assessmentType (le,smt,fmt)
      templateId = _.get(
        _.find(plannerTemplates, template => {
          const templateAssessmentType = _.get(template, "assessmentType");
          const templateType = _.get(template, "type");
          const curriculumProgram = _.get(template, "curriculumProgram", []);

          if (templateAssessmentType) {
            return (
              templateType == groupType &&
              templateAssessmentType == assessmentType &&
              _.some(curriculumProgram, { id: curriculumProgramId })
            );
          } else {
            return (
              templateType == groupType &&
              _.some(curriculumProgram, { id: curriculumProgramId })
            );
          }
        }),
        "id",
        null
      );
    }

    if (_.isNull(templateId)) {
      dispatch(setToastMsg("toastMsgs:template_not_mapped"));
      Sentry.captureMessage("ASSESSMENT_TEMPLATE_NOT_MAPPED", {
        extra: {
          assessmentType,
        },
      });
      return null;
    }

    const fields = _.get(params, "fields", []);

    if (unitType == "ibMYPInterdisciplinary") {
      fields.push({
        uid: "subjects",
        value: _.get(_.find(unitPlanFields, { uid: "subjects" }), "value", []),
      });
    }

    if (assessmentType === ASSESSMENT_TYPE_AI_TUTOR) {
      fields.push(...getAITutorInitialFieldValues());
    }

    return {
      templateId,
      curriculumProgramId,
      fields,
      academicYears,
      type: groupType,
      fixedFields: {
        title: _.isEmpty(title) ? assessmentData.title : title,
        duration: 0,
        description: _.isEmpty(description)
          ? assessmentData.description
          : description,
        assessmentType: taskTypeId || assessmentType,
      },
      unitPlanId,
      learningCourseId,
      createdBy: userId,
      ...(_.isNil(createUnitFlowResource) ? {} : { createUnitFlowResource }),
      taskTypeId,
    };
  };
};

export const createAssessment = (args = {}) => {
  const { groupType = "LEARNING_ENGAGEMENT", unitPlanObj } = args;
  return async (dispatch, getState) => {
    const unitPlanId = _.get(
      unitPlanObj,
      "unitPlanId",
      _.get(getState(), "planner.unitPlanData.unitPlanId", "")
    );
    const filters = getState().assessment.filters;
    const unitPlanResourceDetails = getUnitPlanResourceLibraryFromCache({
      id: unitPlanId,
      filters,
    });
    const resourceEdges = _.get(
      unitPlanResourceDetails.resourceLibrary,
      "edges",
      []
    );

    const input = await dispatch(getCreateAssessmentInputData(args));

    if (_.isEmpty(input)) {
      return null;
    }

    let result = "";
    try {
      await client.mutate({
        mutation: createAssessmentMutation,
        variables: {
          input,
          portalType: "PLANNER",
        },
        // optimisticResponse: {
        //   __typename: "Mutation",
        //   planner: {
        //     __typename: "PlannerMutations",
        //     createAssessment: newAssessment
        //   }
        // },
        update: (
          cache,
          {
            data: {
              planner: { createAssessment },
            },
          }
        ) => {
          result = createAssessment.id;

          if (!result) {
            Sentry.captureMessage("CREATE_ASSESSMENT_ERROR", {
              extra: {
                type: input.type,
                templateId: input.templateId,
              },
            });
          }

          const updatedResourceEdges = [
            {
              type: groupType,
              node: createAssessment,
              __typename: "ResourceLibraryEdge",
            },
            ...resourceEdges,
          ];

          const data = {
            ...unitPlanResourceDetails,
            resourceLibrary: {
              ...unitPlanResourceDetails.resourceLibrary,
              assessmentCount: _.get(updatedResourceEdges, "length", 0),
              edges: updatedResourceEdges,
            },
          };

          setTimeout(() =>
            writeUnitPlanResourceLibraryInCache({
              id: unitPlanId,
              filters,
              data,
            })
          );
        },
      });
    } catch (e) {
      Sentry.captureMessage("CREATE_ASSESSMENT_ERROR", {
        extra: {
          type: input.type,
          templateId: input.templateId,
          reason: _.get(e, "message"),
        },
      });

      setTimeout(() =>
        writeUnitPlanResourceLibraryInCache({
          id: unitPlanId,
          filters,
          data: unitPlanResourceDetails,
        })
      );
    }
    return result;
  };
};

export const deleteAssessment = ({
  assessmentId,
  groupType = "LEARNING_ENGAGEMENT",
  assessmentTypes,
  unitPlanIdFromArgs,
}) => {
  return async (dispatch, getState) => {
    const unitPlanData = getState().planner?.unitPlanData;
    // In the case of slateEditor, We are passing unitPlanId as it is not stored in the redux.
    const unitPlanId = unitPlanIdFromArgs ?? unitPlanData.unitPlanId;
    const filters = getState().assessment.filters;

    const unitPlanResourceDetails = getUnitPlanResourceLibraryFromCache({
      id: unitPlanId,
      filters,
    });

    const resourceEdges = _.get(
      unitPlanResourceDetails.resourceLibrary,
      "edges",
      []
    );

    const currentFlowSection = _.get(
      getState(),
      "unitFlow.currentSection",
      null
    );

    try {
      await client.mutate({
        mutation: deleteAssessmentMutation,
        variables: {
          id: assessmentId,
        },
        awaitRefetchQueries: true,
        refetchQueries: currentFlowSection
          ? [
              {
                query: getChildResourcesFeedQuery,
                variables: { id: currentFlowSection, searchText: "" },
              },
            ]
          : [],
        optimisticResponse: {
          __typename: "Mutation",
          planner: {
            __typename: "PlannerMutations",
            deleteAssessment: true,
          },
        },
        update: (
          cache,
          {
            data: {
              planner: { deleteAssessment },
            },
          }
        ) => {
          if (deleteAssessment) {
            const {
              removeUnitFlowResourcesFromFeed,
            } = getUnitFlowModuleFuncs();
            const { isUnitFlowRevampEnabled } = getUnitFlowUtils();

            dispatch(removeUnitFlowResourcesFromFeed({ ids: [assessmentId] }));
            if (!isUnitFlowRevampEnabled()) {
              const updatedResourceEdges = _.filter(resourceEdges, resource => {
                return resource.node.id != assessmentId;
              });

              const data = {
                ...unitPlanResourceDetails,
                resourceLibrary: {
                  ...unitPlanResourceDetails.resourceLibrary,
                  assessmentCount: _.get(updatedResourceEdges, "length", 0),
                  edges: updatedResourceEdges,
                },
              };
              setTimeout(() =>
                writeUnitPlanResourceLibraryInCache({
                  id: unitPlanId,
                  filters,
                  data,
                })
              );
            }
          }
        },
      });
    } catch (error) {
      setTimeout(() =>
        writeUnitPlanResourceLibraryInCache({
          id: unitPlanId,
          filters,
          data: unitPlanResourceDetails,
        })
      );
      if (error.networkError) {
        dispatch(setToastMsg("toastMsgs:no_internet_connection"));
      } else {
        dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      }
    }
  };
};

export const deleteClonedAssessment = ({ assessmentId, portalType }) => {
  return async (dispatch, getState) => {
    try {
      const result = await client.mutate({
        mutation: deleteAssessmentMutation,
        variables: {
          id: assessmentId,
          portalType,
        },
      });
      return result;
    } catch (err) {
      return false;
    }
  };
};

export const updateAssessmentToolSetting = params => {
  const {
    toolId,
    parentId,
    isTeacherEvaluationEnable,
    isStudentEvaluationEnable,
    parentType,
    assessmentId,
    academicYearId,
  } = params;
  const assessmentDetails = getAssessmentToolOfParentFromCache({
    id: parentId,
    type: parentType,
    assessmentId: assessmentId,
    academicYearId,
  });

  const newAssessmentDetails = _.cloneDeep(assessmentDetails);
  let data;

  // @deperecated we don't use this form Worksheet end (2A)
  if (parentType === "QUESTION") {
    const newOrganizationResources = _.map(
      _.get(
        newAssessmentDetails,
        "organizationResourcesV2.edges[0].node.childrenV2.edges"
      ),
      orgResource => {
        const newEdges = recursiveSearchAndUpdate({
          edges: _.get(orgResource, "node.childrenV2.edges"),
          parentId,
          toolId,
          isTeacherEvaluationEnable,
          isStudentEvaluationEnable,
        });

        return _.set(orgResource, "node.childrenV2.edges", newEdges);
      }
    );

    data = update(newAssessmentDetails, {
      organizationResourcesV2: {
        edges: {
          [0]: {
            node: {
              childrenV2: {
                edges: {
                  $set: newOrganizationResources,
                },
              },
            },
          },
        },
      },
    });
  } else {
    const currentAssessmentTools = _.get(
      newAssessmentDetails,
      "assessmentTools",
      []
    );
    const updatedAssessmentTools = _updateAssessmentTools(
      currentAssessmentTools,
      toolId,
      isTeacherEvaluationEnable,
      isStudentEvaluationEnable
    );

    data = { ...newAssessmentDetails, assessmentTools: updatedAssessmentTools };
  }

  writeAssessmentToolOfParentInCache({
    id: parentId,
    data,
    type: parentType,
    academicYearId,
  });

  return async (dispatch, getState) => {
    try {
      return await client.mutate({
        mutation: updateAssessmentToolSettingMutation,
        variables: _.omit(params, ["assessmentId"]),
      });
    } catch (e) {
      const academicYearId = getSelectedAcademicYearId(getState());
      const collaboratorsFilter = {
        userAcademicYearId: academicYearId,
      };

      writeAssessmentFragment({
        assessmentId: parentId,
        data: assessmentDetails,
        variables: {
          collaboratorsFilter,
        },
      });

      if (e.networkError) {
        dispatch(setToastMsg("toastMsgs:no_internet_connection"));
      } else {
        dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      }
    }
  };
};

export const writeAssessmentWeightageInCache = params => {
  return (dispatch, getState) => {
    const { weightage, assessmentId } = params;

    const academicYearId = getSelectedAcademicYearId(getState());
    const collaboratorsFilter = {
      userAcademicYearId: academicYearId,
    };

    const assessmentDetails = getAssessmentDetailsFromCache({
      id: assessmentId,
      collaboratorsFilter,
    });

    const updatedAssessmentDetails = {
      ...assessmentDetails,
      weightage,
    };

    writeAssessmentFragment({
      assessmentId: assessmentId,
      data: updatedAssessmentDetails,
      variables: {
        collaboratorsFilter,
      },
    });
  };
};

export const saveAssessmentToolUpdateStatusInRedux = ({
  assignmentId,
  toolType,
}) => {
  return (dispatch, getState) => {
    const state = getState();
    const initialAssessmentToolTypes = _.get(
      state,
      "assessment.assessmentData.initialAssessmentToolTypes",
      []
    );

    if (
      _.isEmpty(initialAssessmentToolTypes) ||
      !_.includes(initialAssessmentToolTypes, toolType)
    ) {
      return;
    }

    const assignmentDetails = getAssignmentEditDetailsFromCache({
      id: assignmentId,
      userArchivedFilters: {
        academicYearId: getSelectedAcademicYearId(state),
      },
      isLinkedAssignments: getIsLearningCoursesEnabled(),
    });
    const assignmentState = _.get(assignmentDetails, "state.state");

    if (assignmentState !== "PUBLISHED") {
      return;
    }

    const toolUpdateActivityStatus = _.get(
      state,
      `assessment.fieldUpdateActivityStatus.${toolType}`,
      {}
    );
    const {
      isUpdated = false,
      lastUpdateActivityAt,
    } = toolUpdateActivityStatus;

    if (assignmentId && !isUpdated) {
      dispatch(
        saveFieldUpdateActivityStatus({
          [toolType]: { isUpdated: true, lastUpdateActivityAt },
        })
      );
    }
  };
};

export const registerAssessmentToolUpdateActivity = ({
  assignmentId,
  toolType,
  skipIsUpdated = false,
}) => {
  return (dispatch, getState) => {
    const toolUpdateActivityStatus = _.get(
      getState(),
      `assessment.fieldUpdateActivityStatus.${toolType}`,
      {}
    );
    const {
      isUpdated = false,
      lastUpdateActivityAt,
    } = toolUpdateActivityStatus;

    if (
      (isUpdated || skipIsUpdated) &&
      (_.isEmpty(lastUpdateActivityAt) ||
        getDateTimeDifference({
          date1: getDateMomentObject(),
          date2: getDateMomentObject(lastUpdateActivityAt),
          differenceBy: "minutes",
        }) > 1)
    ) {
      dispatch(
        addAssignmentActivity({
          assignmentId,
          activities: [
            {
              type: "ASSESSMENT_ACTIVITY",
              itemType: "ASSESSMENT_EVALUATION_TOOL_UPDATED",
              metadata: { messageBuild: { toolType } },
            },
          ],
        })
      );
      dispatch(
        saveFieldUpdateActivityStatus({
          [toolType]: {
            isUpdated: false,
            lastUpdateActivityAt: moment().toISOString(),
          },
        })
      );
    }
  };
};

export const getRemovedSubjectDependencies = params => {
  const {
    t,
    curriculumType,
    assessmentTools,
    assessmentFields,
    field_list,
    templateId,
    currentSubjectValue,
    updatedSubjectValue,
    assessmentType,
    sourceFrom,
    assessmentMode,
    isLearningGoalsEvaluationEnabled,
    updatedUnitType,
    isUnitChangeFromEmptyToSubjectSpecific = false,
  } = params;

  return (dispatch, getState) => {
    const isSubjectBasedGrading =
      !getIsLearningCoursesEnabled() || getIsSubjectBasedGradingEnabled();

    const plannerElementSets = _.get(
      getState(),
      "platform.currentPlannerElementSets",
      {}
    );

    // Identify removed subject IDs by comparing current and updated subject values
    const removedSubjectIds = _.difference(
      currentSubjectValue,
      updatedSubjectValue
    );

    const isSubjectSpecificUnitType = updatedUnitType === MYP_SUBJECT_SPECIFIC;

    const isFromUnitSelectionDropdown =
      sourceFrom === "UNIT_SELECTION_DROPDOWN";
    const removedSubjectDependenciesList = [];

    const subjectsResolvedMinimalTree = getResolvedMinimalTree({
      fields: assessmentFields,
      uid: "subjects",
    });

    // Map through the removed subject IDs to get their names
    const subjectNames = _.map(removedSubjectIds, id => {
      return _.find(subjectsResolvedMinimalTree?.subjects, { id })?.name;
    });

    const removedSubjectsLength = _.size(removedSubjectIds);

    // Determine the label for the removed subject(s)
    const removedSubjectLabel =
      removedSubjectsLength > 1
        ? t("classRoom:subjects_with_count", {
            count: removedSubjectsLength,
          })
        : _.first(subjectNames);

    // Determine the subject label text based on the context (unit selection or multiple subjects)
    const subjectLabelText = isFromUnitSelectionDropdown
      ? t("classRoom:the_subject_lowercase")
      : removedSubjectsLength > 1
      ? t("classRoom:the_subjects_lowercase")
      : removedSubjectLabel; // actual subject name

    let headerTitle = "",
      subTitle = "";

    // If it's not from the unit selection dropdown, set the header and subtitle
    const currentAssessmentTypes = dispatch(getCurrentAssessmentTypes());

    const { localeLabel = "", label = "" } =
      currentAssessmentTypes?.[assessmentType] || {};
    const assessmentTypeLabel = localeLabel ? t(localeLabel) : label;

    if (!isFromUnitSelectionDropdown) {
      headerTitle = t("classRoom:remove_label1_from_this_label2", {
        label1: removedSubjectLabel,
        label2: assessmentTypeLabel,
      });

      subTitle = t("classRoom:remove_subject_warning_msg", {
        label1: removedSubjectLabel,
        label2: assessmentTypeLabel,
      });
    } else {
      headerTitle = isUnitChangeFromEmptyToSubjectSpecific
        ? t("classRoom:tag_this_LE_to_a_unit")
        : t("classRoom:change_unit_for_this_task", {
            label: assessmentTypeLabel,
          });

      subTitle = isUnitChangeFromEmptyToSubjectSpecific
        ? t("classRoom:tag_LE_warning_msg")
        : t("classRoom:change_unit_warning_msg", {
            label: assessmentTypeLabel,
          });
    }

    // In case of MYP warn about MYP rubric or IDU rubric if added to the task
    const assessmentToolLabels = [];
    const fieldsToUpdate = {};
    let hasIDURubric;

    // Loop through assessment tools to find rubrics that need to be removed based on removed subjects
    _.forEach(assessmentTools?.edges, ({ node }) => {
      const assessmentToolId = _.get(node, "assessmentToolItem.id");
      const assessmentToolType = _.get(node, "assessmentToolType");

      switch (assessmentToolType) {
        case MYP_OBJECTIVE_RUBRIC:
        case MYP_INTERDISCIPLINARY_CRITERIA_RUBRIC: {
          const rubricTool = _.find(assessmentFields, {
            uid: ASSESSMENT_TOOLS_OBJ[assessmentToolType].objectiveFieldKey,
          });
          const rubricToolNodes = _.get(
            rubricTool,
            "resolvedMinimalTree.nodes",
            []
          );
          const rubricToolLeafNodes = _.filter(rubricToolNodes, {
            isLeaf: true,
          });

          const hasObjectiveRubric =
            assessmentToolType === MYP_OBJECTIVE_RUBRIC;
          hasIDURubric =
            assessmentToolType === MYP_INTERDISCIPLINARY_CRITERIA_RUBRIC;

          // Filter rubric nodes associated with removed subjects
          const removedSubjectObjectivesMYPNodes = hasObjectiveRubric
            ? _.filter(rubricToolLeafNodes, node => {
                const subjects = getNodeParents(node, "SUBJECT");
                return _.some(subjects, ({ id }) =>
                  _.includes(removedSubjectIds, id)
                );
              })
            : [];

          const shouldRemoveMYPRubricTool =
            hasObjectiveRubric &&
            _.size(removedSubjectObjectivesMYPNodes) ===
              _.size(rubricTool?.value);

          // If rubric tool should be removed, add it to fieldsToUpdate
          if (
            !_.isEmpty(rubricTool) &&
            (!_.isEmpty(removedSubjectObjectivesMYPNodes) || hasIDURubric)
          ) {
            if (
              shouldRemoveMYPRubricTool ||
              (!hasObjectiveRubric && isSubjectSpecificUnitType)
            ) {
              fieldsToUpdate[`${assessmentToolType}`] = assessmentToolId;
            }

            const fieldConfig = _.get(field_list, `${rubricTool?.uid}.config`);
            const viewLabel = _.get(fieldConfig, "viewLabel");
            const viewLabelLocale = _.get(fieldConfig, "viewLabelLocale");

            const plannerElementLabel = getPlannerElementLabel({
              t,
              field: rubricTool?.uid,
              templateId,
              curriculumType,
              viewLabel,
              viewLabelLocale,
              plannerElementType: _.get(
                fieldConfig,
                "plannerElementConfig.type",
                ""
              ),
              plannerElementSets,
            });

            if (hasObjectiveRubric || isSubjectSpecificUnitType) {
              assessmentToolLabels.push(plannerElementLabel);
            }
          }

          break;
        }
        case STANDARD_BASED_RUBRIC: {
          if (isSubjectBasedGrading) {
            const standardRubricCriterias = _.get(
              node,
              "assessmentToolItem.standardRubricCriterias",
              []
            );

            const criterionWithStandard = _.find(
              standardRubricCriterias,
              criterion =>
                !_.isNil(criterion?.standard) || !_.isNil(criterion?.benchmark)
            );

            const standardRubricSubjectId =
              _.get(
                criterionWithStandard,
                "standard.standardsWrapper.standardSet.subject.id"
              ) ||
              _.get(
                criterionWithStandard,
                "benchmark.standardsWrapper.standardSet.subject.id"
              );

            if (_.includes(removedSubjectIds, standardRubricSubjectId)) {
              assessmentToolLabels.push(
                t("common:lowercase", {
                  text: t(ASSESSMENT_TOOLS_OBJ[assessmentToolType].locale),
                })
              );

              fieldsToUpdate[`${assessmentToolType}`] = assessmentToolId;
            }
          }

          break;
        }
        case GRADE_SCALE_TOOL: {
          if (isSubjectBasedGrading) {
            const gradeScaleSubjectId = _.get(
              node,
              "assessmentToolItem.entityDetail.subjectId"
            );

            if (_.includes(removedSubjectIds, gradeScaleSubjectId)) {
              assessmentToolLabels.push(
                t("common:lowercase", {
                  text: t(ASSESSMENT_TOOLS_OBJ[assessmentToolType].locale),
                })
              );

              fieldsToUpdate[`${assessmentToolType}`] = assessmentToolId;
            }
          }

          break;
        }
        default:
          break;
      }
    });

    if (!_.isEmpty(assessmentToolLabels)) {
      const assessmentToolsCombinedLabel = joinWithCommaAnd({
        data: assessmentToolLabels,
        t,
      });

      // Create a warning message if there are assessment tools to be removed
      if (assessmentToolsCombinedLabel) {
        const rubricRemovalWarningMsg = t(
          "classRoom:remove_assessment_tools_warning_msg",
          {
            label1: assessmentToolsCombinedLabel,
            label2: subjectLabelText,
          }
        );

        const rubricEvaluationDiscardedWarningMsg = t(
          "classRoom:rubric_evaluations_will_be_discarded_warning_msg"
        );

        // there can be evaluation in edit mode but not in create mode
        const warningLabel =
          assessmentMode === "edit"
            ? `${rubricRemovalWarningMsg} ${rubricEvaluationDiscardedWarningMsg}`
            : rubricRemovalWarningMsg;

        removedSubjectDependenciesList.push({
          id: generateRandomIdV2(),
          label: warningLabel,
          fieldsToUpdate,
        });
      }
    }

    const learningGoalFields = _.chain(field_list)
      .get("addLearningGoals.config.options", [])
      .map("key")
      .value();

    // Get all the tagged learning goals for the subject that is being removed
    const learningGoalLabels = [];
    const learningGoalsToUpdate = {};
    _.forEach(assessmentFields, ({ uid, value }) => {
      const isLearningGoalField = _.includes(learningGoalFields, uid);
      const hasInterdisciplinaryCriteriaMYP =
        _.isEqual(uid, "interdisciplinaryCriteriaMYP") && !_.isEmpty(value);

      if (isLearningGoalField) {
        const resolvedMinimalTreeNodes = getResolvedMinimalTreeSet({
          fields: assessmentFields,
          uid,
          curriculumType,
        });

        const nodes = _.filter(resolvedMinimalTreeNodes, node => {
          const { id } = node || {};
          return _.includes(value, id);
        });

        // Filter out learning goals associated with removed subjects
        const currentSubjectNodes = _.filter(nodes, node => {
          const subjects = getNodeParents(node, "SUBJECT");

          return (
            _.some(subjects, ({ id }) => _.includes(removedSubjectIds, id)) ||
            _.includes(removedSubjectIds, node?.subject)
          );
        });

        const fieldConfig = _.get(field_list, `${uid}.config`);
        const viewLabel = _.get(fieldConfig, "viewLabel");
        const viewLabelLocale = _.get(fieldConfig, "viewLabelLocale");

        if (
          !_.isEmpty(currentSubjectNodes) ||
          (hasInterdisciplinaryCriteriaMYP && isSubjectSpecificUnitType)
        ) {
          const plannerElementLabel = getPlannerElementLabel({
            t,
            field: uid,
            templateId,
            curriculumType,
            viewLabel,
            viewLabelLocale,
            plannerElementType: _.get(
              fieldConfig,
              "plannerElementConfig.type",
              ""
            ),
            plannerElementSets,
          });

          const currentSubjectNodeIds = _.map(
            currentSubjectNodes,
            node => node?.id
          );

          learningGoalLabels.push(plannerElementLabel);
          learningGoalsToUpdate[uid] = !_.isEmpty(currentSubjectNodeIds)
            ? _.filter(value, id => {
                return !_.includes(currentSubjectNodeIds, id);
              })
            : [];
        }
      }
    });

    const learningGoalsCombinedLabel = joinWithCommaAnd({
      data: learningGoalLabels,
      t,
    });

    if (learningGoalsCombinedLabel) {
      const learningGoalsRemovalWarningMsg = t(
        "classRoom:remove_learning_goals_warning_msg",
        {
          label1: learningGoalsCombinedLabel,
          label2: subjectLabelText,
        }
      );
      const learningGoalsEvaluationDiscardedWarningMsg = t(
        "classRoom:learning_goals_evaluation_discarded"
      );

      // there can be evaluation in edit mode but not in create mode
      const warningLabel = isLearningGoalsEvaluationEnabled
        ? `${learningGoalsRemovalWarningMsg} ${learningGoalsEvaluationDiscardedWarningMsg}`
        : learningGoalsRemovalWarningMsg;

      removedSubjectDependenciesList.push({
        id: generateRandomIdV2(),
        label: warningLabel,
        fieldsToUpdate: learningGoalsToUpdate,
      });
    }

    if (_.isEmpty(removedSubjectDependenciesList)) {
      return {};
    }

    if (isFromUnitSelectionDropdown && removedSubjectsLength > 0) {
      removedSubjectDependenciesList.unshift({
        id: generateRandomIdV2(),
        label: t("classRoom:update_associated_subjects"),
      });
    }

    return {
      subjectDependencies: removedSubjectDependenciesList,
      headerTitle,
      subTitle,
    };
  };
};

export const updateTitleFromLTIAttachment = ({ assessmentId }) => {
  return async (dispatch, getState) => {
    const state = getState();
    const academicYearId = getSelectedAcademicYearId(state);
    const collaboratorsFilter = {
      userAcademicYearId: academicYearId,
    };

    const assessmentDetails = getAssessmentDetailsFromCache({
      id: assessmentId,
      collaboratorsFilter,
    });

    const titleField = _.find(assessmentDetails?.allFields, {
      uid: "title",
    });

    const titleValue = _.get(titleField, "value");

    if (_.isEmpty(_.trim(titleValue))) {
      const studentTemplateField = _.find(assessmentDetails?.allFields, {
        uid: "studentTemplate",
      });

      const attachments = _.get(
        studentTemplateField,
        "resolvedMinimalTree.attachmentGroups[0].attachments",
        []
      );

      const ltiAttachment = _.find(
        attachments,
        att => _.get(att, "metadata.type") === "LTI_TOOL"
      );

      const label = _.get(ltiAttachment, "metadata.lineitem.label");

      if (!_.isEmpty(label)) {
        await updateAssessment({
          assessmentId: assessmentId,
          fieldUID: "title",
          id: _.get(titleField, "id"),
          value: label,
        });

        updateAssessmentInCache({
          assessmentId: assessmentId,
          fieldUID: "title",
          id: _.get(titleField, "id"),
          value: label,
        });
      }
    }
  };
};

export const createCourseFlowResources = ({
  resources,
  learningCourseId,
  isDraft,
  parentId = null,
}) => {
  return async dispatch => {
    if (_.isEmpty(resources)) return;

    try {
      const variables = {
        input: {
          learningCourseId,
          parentId,
          putAfterItemId: null,
          resources,
          addToTop: false,
        },
        portalType: "PLANNER",
        syncedBluePrintItemFilters: {
          learningCourseId,
        },
      };

      await client.mutate({
        mutation: createCourseFlowResourceMutation,
        variables,
      });

      if (isDraft) {
        dispatch(
          setToastMsg({
            type: "success",
            msg: "toastMsgs:le_added_to_course_flow",
          })
        );
      }
    } catch (error) {
      console.error(error);
    }
  };
};

// For 2.0 orgs: when an assignment is tagged to a unit, pre-create the course
// flow resource nested inside the unit before createAssignment runs. The backend
// detects the pre-existing resource and places the assignment there rather than
// at the course flow root.
export const createCourseFlowResourceInsideUnit = ({
  unitPlanId,
  learningCourseId,
  assessmentId,
}) => {
  return async dispatch => {
    try {
      const result = await client.query({
        query: getLearningCourseFlowResourceQuery,
        variables: { id: unitPlanId },
        fetchPolicy: "cache-first",
      });
      const courseFlowResourceId = _.get(
        result,
        "data.node.learningCourseFlowResource.id",
        null
      );
      if (courseFlowResourceId) {
        await dispatch(
          createCourseFlowResources({
            learningCourseId,
            resources: [
              {
                label: "",
                itemId: assessmentId,
                itemType: "ASSESSMENT",
              },
            ],
            parentId: courseFlowResourceId,
          })
        );
      }
    } catch (error) {
      console.error(error);
    }
  };
};
